var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_3023)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_0_3023)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4997 3.95833C11.9747 3.95833 13.2956 4.46667 14.3372 5.45833L17.1914 2.60417C15.4581 0.991667 13.1956 0 10.4997 0C6.59141 0 3.21224 2.24167 1.56641 5.50833L4.89141 8.0875C5.67891 5.71667 7.89141 3.95833 10.4997 3.95833Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.075 10.2288C20.075 9.57467 20.0125 8.94134 19.9167 8.33301H10.5V12.0913H15.8917C15.65 13.3247 14.95 14.3747 13.9 15.083L17.1208 17.583C19 15.8413 20.075 13.2663 20.075 10.2288Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.8875 11.913C4.6875 11.3088 4.57083 10.6671 4.57083 10.0005C4.57083 9.33379 4.68333 8.69212 4.8875 8.08796L1.5625 5.50879C0.883333 6.85879 0.5 8.38379 0.5 10.0005C0.5 11.6171 0.883333 13.1421 1.56667 14.4921L4.8875 11.913Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 19.9999C13.2 19.9999 15.4708 19.1124 17.1208 17.579L13.9 15.079C13.0042 15.6832 11.85 16.0374 10.5 16.0374C7.89167 16.0374 5.67917 14.279 4.8875 11.9082L1.5625 14.4874C3.2125 17.7582 6.59167 19.9999 10.5 19.9999Z",
    fill: "#34A853"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_3023"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_0_3023"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/GoogleLogo.13dbe614ad929ca4b9eb7225a0b4710e.svg";
export { ForwardRef as ReactComponent };